(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cutting-board-hero"] && !Shopify.designMode) return;
  try {
    
  class CuttingBoardHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cb-hero-track]');
      this.thumbs = [...this.querySelectorAll('[data-cb-hero-thumb]')];
      this.addEventListener('click', this.handleClick);
      this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
      document.addEventListener('variant:update', this.handleVariantUpdate);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.track?.removeEventListener('scroll', this.handleScroll);
      document.removeEventListener('variant:update', this.handleVariantUpdate);
    }
    handleClick = (event) => {
      const thumb = event.target.closest('[data-cb-hero-thumb]');
      if (!thumb) return;
      this.querySelector(`[data-media-id="${thumb.dataset.mediaId}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };
    handleScroll = () => {
      if (!this.track) return;
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      this.thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
    };
    handleVariantUpdate = (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const updatedPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
      const price = this.querySelector('[data-cb-hero-price]');
      if (updatedPrice && price) price.innerHTML = updatedPrice.innerHTML;
      const title = event.detail.resource?.public_title || event.detail.resource?.title;
      if (title) {
        this.querySelectorAll('.cb-hero__variant-value').forEach((value) => value.classList.toggle('is-selected', title.includes(value.textContent.trim())));
      }
      const mediaId = event.detail.resource?.featured_media?.id;
      if (mediaId) this.querySelector(`[data-cb-hero-thumb][data-media-id="${mediaId}"]`)?.click();
    };
  }
  if (!customElements.get('cutting-board-hero')) customElements.define('cutting-board-hero', CuttingBoardHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
